import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  Divider,
  Container,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: 'Startseite', path: '/' },
    { text: 'Rechtliches', path: '/rechtliches' },
  ];



  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: 'white',
          borderBottom: '1px solid #e0e0e0',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        }}
        elevation={0}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ py: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Box
              component={Link}
              to="/"
              sx={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            >
              <Box
                component="img"
                src="/images/LOGO Stempel.png"
                alt="DAD-Service Logo"
                sx={{
                  width: { xs: 40, md: 50 },
                  height: { xs: 40, md: 50 },
                  mr: 2,
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                }}
              />
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: 'primary.main',
                    fontSize: { xs: '1.1rem', md: '1.25rem' },
                    lineHeight: 1.2,
                  }}
                >
                  DAD-Service
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.secondary',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                    display: { xs: 'block', md: 'block' },
                  }}
                >
                  Elektromeisterbetrieb
                </Typography>
              </Box>
            </Box>
          </Box>

          {isMobile ? (
            <IconButton
              color="primary"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                backgroundColor: 'rgba(26, 54, 93, 0.04)',
                '&:hover': {
                  backgroundColor: 'rgba(26, 54, 93, 0.08)',
                },
              }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              {menuItems.map((item) => (
                <Button
                  key={item.text}
                  component={Link}
                  to={item.path}
                  sx={{
                    px: 2,
                    py: 1,
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    color: location.pathname === item.path ? 'primary.main' : 'text.primary',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: 'rgba(26, 54, 93, 0.04)',
                    },
                  }}
                >
                  {item.text}
                </Button>
              ))}

              {/* CTA Button */}
              <Button
                variant="contained"
                onClick={() => {
                  if (location.pathname === '/') {
                    // If on home page, scroll to contact form
                    window.scrollTo({ top: document.getElementById('contact-form')?.offsetTop || 0, behavior: 'smooth' });
                  } else {
                    // If on other page, navigate to home and then scroll
                    window.location.href = '/#contact-form';
                  }
                }}
                sx={{
                  ml: 1,
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                  fontSize: '0.95rem',
                }}
              >
                Kontakt
              </Button>
            </Box>
          )}
        </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 280,
            backgroundColor: 'white',
          },
        }}
      >
        <Box sx={{ p: 3, textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>
          <Box
            component="img"
            src="/images/LOGO Stempel.png"
            alt="DAD-Service Logo"
            sx={{
              width: 50,
              height: 50,
              mb: 2,
            }}
          />
          <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
            DAD-Service
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Elektromeisterbetrieb
          </Typography>
        </Box>

        <Box sx={{ p: 2 }}>
          {menuItems.map((item) => (
            <Button
              key={item.text}
              component={Link}
              to={item.path}
              fullWidth
              onClick={handleDrawerToggle}
              sx={{
                justifyContent: 'flex-start',
                py: 1.5,
                px: 2,
                mb: 1,
                color: location.pathname === item.path ? 'primary.main' : 'text.primary',
                borderRadius: '8px',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: 'rgba(26, 54, 93, 0.04)',
                },
              }}
            >
              {item.text}
            </Button>
          ))}

          <Divider sx={{ my: 2 }} />

          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              if (location.pathname === '/') {
                // If on home page, scroll to contact form
                window.scrollTo({ top: document.getElementById('contact-form')?.offsetTop || 0, behavior: 'smooth' });
              } else {
                // If on other page, navigate to home and then scroll
                window.location.href = '/#contact-form';
              }
              handleDrawerToggle();
            }}
            sx={{
              py: 1.5,
              px: 2,
              fontWeight: 600,
            }}
          >
            Kontakt aufnehmen
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;